// Copyright (c) Konnecta Systems. All rights reserved.
// Licensed under the Custom License. See LICENSE file in the project root for full license information.
// This was autogenerated by zAppDev.
import { System } from 'src/app/@framework/core/clms.fw.dotnet';
import * as Domain from '../Domain';
import * as Common from '../../@framework/common';
import { CLMS  } from 'src/app/@framework/core/clms.fw.common';
import { Joove } from 'src/app/@framework/core/Joove';
import * as moment from 'moment';
import { TranslateService } from '@ngx-translate/core';
import { DataListColumnInfo, DataListColumnItemType, ListDynamicColumnValue } from '@framework/components/DataList/helpers/List.helper.classes';
import { ValueFormat } from '@framework/core/clms.fw.angular';
var numeral = require('numeral');
const VerEx = require('verbal-expressions');


export class TimesheetReport  {
    _originalTypeClassName = "Loom.BO.TimesheetReport";
constructor(protected translateService: TranslateService = null) {
if (translateService != null) {
TimesheetReport.translate = translateService;
}
this.TimesheetEntries = [];
this.Id = null;
this.Period = null;
this.TotalHours = null;
this.DateApproved = null;
this.DateSubmitted = null;
this.SubmittedBy = null;
this.ApprovedBy = null;
this._key = this.Id = 0; 
}

static translate: TranslateService;
_key: any;
private _Id:any;
get Id(): any {
    return this._Id;
  }
set Id(value: any) {
    this._Id = value;
    this._key = value;
  }
Period:any;
TotalHours:any;
DateApproved:any;
DateSubmitted:any;
SubmittedBy:any;
ApprovedBy:any;
Project:any;
Beneficiary:any;
Employee:any;
TimesheetEntries:any;
static setProject = ($this, value) => {
var oldValue = $this.Project;
$this.Project = value;
if (value != null) {
}
}
static setBeneficiary = ($this, value) => {
var oldValue = $this.Beneficiary;
$this.Beneficiary = value;
if (value != null) {
}
}
static setEmployee = ($this, value) => {
var oldValue = $this.Employee;
$this.Employee = value;
if (value != null) {
}
}
static setTimesheetEntries = ($this, items) => {
                if (items == null) items = [];
                if ($this.TimesheetEntries == null) $this.TimesheetEntries = [];

                const copyItems = Common.cloneObject(items);

                while ($this.TimesheetEntries.length > 0) {
                    Domain.TimesheetReport.removeTimesheetEntries($this, $this.TimesheetEntries[0]);
                }

                Domain.TimesheetReport.addManyTimesheetEntries($this, copyItems);
            }
static addManyTimesheetEntries = ($this, items) => {
                if (items == null) return;
                for (let i = 0; i < items.length; i++) {
                    Domain.TimesheetReport.addTimesheetEntries($this, items[i]);
                }
            }
static addTimesheetEntries = ($this, item) => {
                if ($this.TimesheetEntries == null) $this.TimesheetEntries = [];
                if (item == null || $this.TimesheetEntries.indexOf(item) > -1) return;
                $this.TimesheetEntries.push(item);
}
static addRangeTimesheetEntries = ($this, items: System.Collections.List<any>) => { 
                items.forEach(item => Domain.TimesheetReport.addTimesheetEntries($this, item));
            }
static removeTimesheetEntries = ($this, item) => {
                if ($this == null || $this.TimesheetEntries == null || $this.TimesheetEntries.indexOf(item) === -1) return;
                var _index = $this.TimesheetEntries.indexOf(item);
                $this.TimesheetEntries.splice(_index, 1);
}
static clearTimesheetEntries = ($this) => { $this.TimesheetEntries = null; }


static IsNew($this: any): boolean {
                if ($this == null) return true;
                return $this.Id == null || $this.Id == 0;
            }


}